import React, { useState, useContext, useEffect } from "react";
import { format } from "date-fns";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import Breadcrumbs from "../../Navigation/Components/Breadcrumbs";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./NewPersonForm.css";

function NewPersonForm() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [profile, setProfile] = useState("");
  const [role, setRole] = useState("user");
  const [boss, setBoss] = useState("");
  const [inactive, setInactive] = useState(false);
  const [show, setShow] = useState(true);
  const [birthDate, setBirthDate] = useState("");
  const [entryDate, setEntryDate] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);

  const [users, setUsers] = useState([]);
  const [profiles, setProfiles] = useState([]);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/form/data/${state.organization}`,
        data: {
          language: state.language,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setProfiles(response.data.profiles);
      setUsers(response.data.users);
    }
    fetch();
  }, [state.language, state.organization, state.token]);

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePidChange = (e) => {
    setEmployeeId(e.target.value);
  };

  const handleProfileChange = (e) => {
    setProfile(e.target.value);
  };

  const handleRoleChange = (e) => {
    setRole(e.target.value);
  };

  const handleBossChange = (e) => {
    setBoss(e.target.value);
  };

  const handleInactiveChange = (e) => {
    setInactive(e.target.checked);
  };

  const handleShowChange = (e) => {
    setShow(e.target.checked);
  };

  const handleProfilePictureChange = (e) => {
    setProfilePicture({ name: e.target.name, file: e.target.files[0] });
  };

  const handleSubmit = async () => {
    try {
      const formData = new FormData();
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("email", email);
      formData.append("employeeId", employeeId);
      formData.append("inactive", inactive);
      formData.append("show_org", show);
      formData.append("organization", state.organization);
      formData.append("role", role);
      formData.append("profile", profile);
      formData.append("boss", boss);
      formData.append(
        "birthDate",
        birthDate !== "" && birthDate !== null
          ? format(birthDate, "yyyy-MM-dd")
          : "",
      );
      formData.append(
        "entryDate",
        entryDate !== "" && entryDate !== null
          ? format(entryDate, "yyyy-MM-dd")
          : "",
      );
      if (profilePicture !== null) {
        formData.append(profilePicture.name, profilePicture.file);
      }

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/users`,
        data: formData,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/people");
    } catch (error) {
      console.log(error);
      toast(error.response.data.message);
    }
  };

  let breadcrumbs = [
    {
      title: "Personas",
      path: "/people",
    },
  ];

  return (
    <Container fluid>
      <ToastContainer />
      <Row>
        <Breadcrumbs data={breadcrumbs} />
      </Row>
      <Row>
        <Col className="new-person-header">
          <h2>{t("Personas.Persona.NewForm.Titulo")}</h2>
        </Col>
      </Row>
      <Row>
        <Col className="new-person-form">
          <Form>
            <Row className="justify-content-center">
              <Col className="center mb-5 mt-5">
                <FontAwesomeIcon icon={faUser} size="10x" className="avatar" />
              </Col>
            </Row>
            <Row>
              <Col className="mb-3">
                <Form.Label>{t("Personas.Persona.NewForm.Nombres")}</Form.Label>
                <Form.Control type="text" onChange={handleFirstNameChange} />
              </Col>
              <Col className="mb-3">
                <Form.Label>
                  {t("Personas.Persona.NewForm.Apellidos")}
                </Form.Label>
                <Form.Control type="text" onChange={handleLastNameChange} />
              </Col>
            </Row>
            <Row>
              <Col className="mb-3">
                <Form.Label>{t("Personas.Persona.NewForm.Email")}</Form.Label>
                <Form.Control type="email" onChange={handleEmailChange} />
              </Col>
              <Col className="mb-3">
                <Form.Label>
                  {t("Personas.Persona.NewForm.IdEmpleado")}
                </Form.Label>
                <Form.Control type="text" onChange={handlePidChange} />
              </Col>
            </Row>
            <Row>
              <Col className="mb-3">
                <Form.Label>{t("Personas.Persona.NewForm.Perfil")}</Form.Label>
                <Form.Select aria-label="Perfil" onChange={handleProfileChange}>
                  <option> </option>
                  {profiles.map((item) => (
                    <option key={item._id} value={item._id}>
                      {state.language === "es" ? item.name : item.name_english}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col className="mb-3">
                <Form.Label>
                  {t("Personas.Persona.NewForm.RolUsuario")}
                </Form.Label>
                <Form.Select
                  aria-label="Rol"
                  onChange={handleRoleChange}
                  value={role}
                >
                  <option> </option>
                  <option value="user">
                    {t("Personas.Persona.NewForm.Usuario")}
                  </option>
                  <option value="admin">
                    {t("Personas.Persona.NewForm.Administrador")}
                  </option>
                  {state.role === "root" || state.role === "owner" ? (
                    <option value="owner">
                      {t("Personas.Persona.NewForm.Owner")}
                    </option>
                  ) : (
                    <></>
                  )}
                </Form.Select>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t("Personas.Persona.NewForm.JefeDirecto")}
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    onChange={handleBossChange}
                  >
                    <option> </option>
                    {users.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.firstName} {item.lastName}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Imagen de Perfil</Form.Label>
                  <Form.Control
                    type="file"
                    name="profilePicture"
                    onChange={(e) => handleProfilePictureChange(e)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t("Personas.Persona.NewForm.FechaNacimiento")}
                  </Form.Label>
                  <DatePicker
                    showIcon
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={birthDate}
                    onChange={(date) => setBirthDate(date)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t("Personas.Persona.NewForm.FechaIngreso")}
                  </Form.Label>
                  <DatePicker
                    showIcon
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={entryDate}
                    onChange={(date) => setEntryDate(date)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col>
                <Form.Check
                  inline
                  label={t("Personas.Persona.EditForm.Inactivo")}
                  name="group1"
                  type="switch"
                  onChange={handleInactiveChange}
                />
                <Form.Check
                  inline
                  label={t("Personas.Persona.EditForm.MostrarOrganigrama")}
                  name="group2"
                  type="switch"
                  onChange={handleShowChange}
                />
              </Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t("Personas.Persona.NewForm.Guardar")}
                </Button>
                <Link to="/people">
                  <Button className="danger">
                    {t("Personas.Persona.NewForm.Cancelar")}
                  </Button>
                </Link>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default NewPersonForm;
